/**
 * Return navigation for the Encompass Processing Requests entry only.
 * Authentication still uses the existing employee login and OAuth callback.
 */
// Reuse the navigation-state namespace preserved by existing startup cleanup.
// This contains a validated destination only, never authentication credentials.
export const PROCESSING_REQUEST_REDIRECT_KEY = 'auth-redirect-path:processing-requests';
const INTERNAL_BASE = 'https://processing-requests.invalid';

export function isProcessingRequestDestination(destination: string): boolean {
  if (!destination.startsWith('/internal/conditions/') || destination.includes('\\')) {
    return false;
  }
  try {
    const url = new URL(destination, INTERNAL_BASE);
    return url.origin === INTERNAL_BASE &&
      /^\/internal\/conditions\/[^/]+$/.test(url.pathname) &&
      url.searchParams.get('view') === 'title-escrow' &&
      url.searchParams.get('from') === 'encompass';
  } catch {
    return false;
  }
}

export function storeProcessingRequestRedirect(destination: string): boolean {
  if (!isProcessingRequestDestination(destination)) {
    return false;
  }
  // If storage fails, do not start OAuth and lose the intended loan.
  sessionStorage.setItem(PROCESSING_REQUEST_REDIRECT_KEY, destination);
  return true;
}

/** An invalid stored value must not fall through to another tab's loan. */
export function readProcessingRequestRedirect(): string | null {
  try {
    const destination = sessionStorage.getItem(PROCESSING_REQUEST_REDIRECT_KEY);
    if (destination === null) {
      return null;
    }
    return isProcessingRequestDestination(destination) ? destination : '/internal';
  } catch {
    // Storage restrictions must not change ordinary portal sign-in.
    return null;
  }
}

export function clearProcessingRequestRedirect(): void {
  try {
    sessionStorage.removeItem(PROCESSING_REQUEST_REDIRECT_KEY);
  } catch {
    // Ordinary portal sign-in does not depend on this integration's storage.
  }
}
